import { constructUrl } from "@pathwright/features/src/modules/utils/urls"
import { clearAuthToken } from "@pathwright/utils/src/token/utils"

const request = require("../api/request")

export const bootstrapSchool = function (schoolURL) {
  // Returns a promise
  let configURL = `${constructUrl(schoolURL)}config.json`
  if (configURL.indexOf("http") === -1) {
    configURL = `http://${configURL}`
  }
  return request
    .get(configURL)
    .then(function (bootstrappedData) {
      window.bootstrappedData = bootstrappedData
      return bootstrappedData
    })
    .catch(function (error) {
      console.error(error)
      if (error.response && error.response.status === 401) {
        // invalid token?, try again
        clearAuthToken()
        return bootstrapSchool(schoolURL)
      } else {
        throw error
      }
    })
}
